import React from "react";
import { Spinner } from "react-bootstrap";
import { deriveCheckoutSubmitState } from "./checkoutSubmitButtonState";

function CheckoutSubmitButton({
  isSubmitting,
  cartItemCount,
  rangeStatus,
  total,
  fontFamily,
}) {
  const { disabled, label } = deriveCheckoutSubmitState({
    isSubmitting,
    cartItemCount,
    rangeStatus,
    total,
  });

  return (
    <button
      type="submit"
      disabled={disabled}
      style={{
        width: "100%",
        padding: "16px",
        borderRadius: 14,
        border: "none",
        background: disabled ? "rgba(0,122,255,0.4)" : "#007AFF",
        color: "#fff",
        fontSize: "1rem",
        fontWeight: 600,
        letterSpacing: "-0.012em",
        cursor: disabled ? "not-allowed" : "pointer",
        fontFamily,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 10,
        transition: "opacity 0.15s ease",
      }}
      data-testid="checkout-submit-button"
    >
      {isSubmitting && (
        <Spinner
          as="span"
          animation="border"
          size="sm"
          style={{ width: 17, height: 17, borderWidth: 2 }}
        />
      )}
      {label}
    </button>
  );
}

export default CheckoutSubmitButton;
